import { MixpanelPropertiesProvider, MixpanelProperty, PageViewTracker, usePageTitleUpdater } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";

const MigrationAssessmentSource = {
    [MixpanelProperty.Source]: "Migration Assessment"
};

export function ModuleGlobalProviders({ children }: PropsWithChildren) {
    usePageTitleUpdater();

    return (
        <MixpanelPropertiesProvider value={MigrationAssessmentSource}>
            {children}
            <PageViewTracker />
        </MixpanelPropertiesProvider>
    );
}
